export default __webpack_public_path__ + "static/media/blog4.d36b3323.jpg";